import { JSX } from "react";

import { MODULE_PULL_REQUESTS_COLUMN_ID } from "../../constants";
import { ModulePullRequestsTablePullRequestCellProps } from "../types";
import ModulePullRequestsTablePullRequestActionsCell from "./ActionsCell";
import ModulePullRequestsTablePullRequestAuthorCell from "./AuthorCell";
import ModulePullRequestsTablePullRequestBranchCell from "./BranchCell";
import ModulePullRequestsTablePullRequestDeltaCell from "./DeltaCell";
import ModulePullRequestsTablePullRequestOpenedAtCell from "./OpenedAtCell";
import ModulePullRequestsTablePullRequestPrCell from "./PrCell";
import ModulePullRequestsTablePullRequestStatusCell from "./StatusCell";
import ModulePullRequestsTablePullRequestTitleCell from "./TitleCell";
import ModulePullRequestsTablePullRequestUpdatedAtCell from "./UpdatedAtCell";
import ModulePullRequestsTablePullRequestVendorCell from "./VendorCell";

export const MODULE_PULL_REQUESTS_PULL_REQUEST_CELLS: Record<
  string,
  (props: ModulePullRequestsTablePullRequestCellProps) => JSX.Element
> = {
  [MODULE_PULL_REQUESTS_COLUMN_ID.STATUS]: ModulePullRequestsTablePullRequestStatusCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.TITLE]: ModulePullRequestsTablePullRequestTitleCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.PR]: ModulePullRequestsTablePullRequestPrCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.BRANCH]: ModulePullRequestsTablePullRequestBranchCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.AUTHOR]: ModulePullRequestsTablePullRequestAuthorCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.VENDOR]: ModulePullRequestsTablePullRequestVendorCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.DELTA]: ModulePullRequestsTablePullRequestDeltaCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.OPENED_AT]: ModulePullRequestsTablePullRequestOpenedAtCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.UPDATED_AT]: ModulePullRequestsTablePullRequestUpdatedAtCell,
  [MODULE_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: ModulePullRequestsTablePullRequestActionsCell,
};
